import {
    Box,
    Button,
    Dialog,
    Group,
    Text,
    Textarea,
    TextInput,
} from "@mantine/core";
import { IconAlertTriangle } from "@tabler/icons";
import { useState } from "react";

const ReportConcern = ({ concern_type = "question", additional_data = {} }) => {
    const [opened, setOpened] = useState(false);
    const [loading, setLoading] = useState(false);

    return (
        <Box>
            <Button
                color={"orange"}
                leftIcon={<IconAlertTriangle />}
                onClick={() => setOpened((o) => !o)}
            >
                Facing Issues?
            </Button>
            <Dialog
                opened={opened}
                withCloseButton
                onClose={() => {
                    setOpened(false);
                }}
                size="lg"
                radius="md"
            >
                <Text size="sm" style={{ marginBottom: 10 }} weight={500}>
                    Is there any problem with this {concern_type}?
                </Text>

                <Group align="flex-end">
                    <Textarea
                        placeholder="Tell us your concern"
                        style={{ flex: 1 }}
                        // description="Please let us know what we can improve"
                        required
                    />
                    <Button
                        onClick={() => {
                            setLoading(true);
                            setTimeout(() => {
                                setOpened(false);
                                setLoading(false);
                            }, 2000);
                        }}
                        loading={loading}
                    >
                        {!loading && "Send"}
                        {loading && "Sending"}
                    </Button>
                </Group>
            </Dialog>
        </Box>
    );
};

export default ReportConcern;
